// Tiny dev-only logger. In production builds these are no-ops so nothing
// leaks to end-users' devtools and there's no perf overhead on hot paths.
const IS_DEV = process.env.NODE_ENV !== "production";

export const devLog = (...args) => {
  if (IS_DEV) console.log(...args);
};

export const devDebug = (...args) => {
  if (IS_DEV) console.debug(...args);
};

export const devWarn = (...args) => {
  if (IS_DEV) console.warn(...args);
};
